export const userCredential = "USER_CREDENTIAL";
export const addError = "ADD_ERROR";
export const removeError = "REMOVE_ERROR";
export const removeAllError = "REMOVE_ALL_ERROR";
